import React from 'react';
import './banner.css'
import me from '../../assets/me.jpg'
import Typewriter from 'typewriter-effect';
import 'animate.css';
const Banner = () => {
    <Typewriter
        options={{
            strings: ['Hello', 'World'],
            autoStart: true,
            loop: true,
        }}
    />
    return (
        <div className='grid grid-cols-1 mx-3 mb-10 lg:mb-0 lg:mt-10 lg:mx-40 lg:grid-cols-2 banner my-element '>
            <div className='flex items-center'>
                <div className='mx-auto'>
                    <p className='text-xl font-semibold hello'>
                        Hellow,I'm
                    </p>
                    <h1 className='text-4xl font-bold lg:text-5xl text-slate-800'>Maruf Hasan</h1>
                    <h2 className='mt-3 text-xl font-semibold des'><Typewriter options={{
                        strings: ['M E R N STACK', 'Web developer'],
                        autoStart: true,
                        loop: true,
                    }}></Typewriter></h2>
                    <a href="https://drive.google.com/file/d/13g31JYXVzrpbPqAL87Y1-tg9aqu8MGzF/view?usp=sharing" target="_blank" className="mt-4 btn resumebtn" rel="noreferrer">Download Resume</a>
                </div>
            </div>
            <div className='flex items-center justify-center w-full me my-9 lg:my-0'>
                <div><img src={me} alt="" className='h-96 lgimg ' /></div>
            </div>
        </div>
    );
};

export default Banner;